import React from 'react';

import classNames from 'classnames';
import { RefreshFilled } from '@weee-fe/kunlunicon';
import { twMerge } from 'tailwind-merge';
export interface Props {
  className?: string;
  type?: 'default' | 'primary' | 'disable' | 'secondary' | 'tertiary' | 'confirmation';
  children?: React.ReactNode | string | React.ReactNode[];
  inline?: boolean;
  onClick?: (e?) => void;
  bordered?: boolean;
  disabled?: boolean;
  stretchButton?: boolean;
  loading?: boolean;
  tag?: any;
  isEnki?: boolean;
  size?: 'default' | 'large' | 'small' | 'xs' | '2xs';
  dataTestId?: string;
  [key: string]: any;
}

export default function Button(props: Props) {
  const {
    className,
    children,
    type = 'default',
    inline = false,
    disabled = false,
    bordered = false,
    stretchButton = false,
    loading = false,
    tag = 'button',
    onClick,
    htmlType,
    preventDefault = false,
    isEnki,
    size = 'default',
    dataTestId,
    ...rest
  } = props;

  const Tag = tag;
  const handleClick = e => {
    preventDefault && e.preventDefault();
    if (!disabled && !loading) {
      onClick?.(e);
    }
  };

  return (
    <Tag
      data-testid={dataTestId}
      {...rest}
      onClick={handleClick}
      type={htmlType}
      className={twMerge(
        classNames(
          'flex w-full outline-0 items-center justify-center bg-surface-100-bg text-surface-100-fg-default border-none text-center rounded-full break-words whitespace-nowrap cursor-pointer',
          {
            'inline-block w-unset': inline,
            'w-auto flex-grow': stretchButton,
            'border border-solid border-surface-100-hairline': bordered,
            'bg-btn-primary-bg text-btn-primary-fg-default': type === 'primary',
            'bg-btn-confirmation-bg text-btn-confirmation-fg-default': type === 'confirmation',
            'bg-btn-secondary-bg text-btn-secondary-fg-default': type === 'secondary',
            'bg-btn-tertiary-bg text-btn-tertiary-fg-default': type === 'tertiary',
            'h-1200 enki-body-lg-medium px-600': size === 'large',
            'h-1000 enki-body-base-medium px-500': size === 'default',
            'h-900 enki-body-sm-medium px-400': size === 'small',
            'h-800 enki-body-xs-medium px-300': size === 'xs',
            'h-700 enki-body-2xs-medium px-300': size === '2xs'
          }
        ),
        className,
        (disabled || loading) && 'bg-btn-disabled-bg text-btn-disabled-fg-default cursor-default'
      )}>
      {loading && <RefreshFilled className="animate-spin mr-[10px]" />}
      {children}
    </Tag>
  );
}
